import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  DropzoneDirective,
  DropzoneConfigInterface,
  DropzoneModule,
} from 'ngx-dropzone-wrapper';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'file-upload',
  standalone: true,
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropzoneModule,
  ],
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @Output() filesDropped = new EventEmitter<File[]>();
  @Output() filesSelected = new EventEmitter<Event>();

  isDragging = false;

  config: DropzoneConfigInterface = {
    clickable: false, 
    acceptedFiles: 'image/*',
    maxFiles: 5,
    maxFilesize: 10,
    autoReset: null,
    errorReset: null,
    cancelReset: null,
  };

  @ViewChild(DropzoneDirective, { static: false }) directiveRef?: DropzoneDirective;

  constructor(
    private readonly dialogRef: MatDialogRef<FileUploadComponent>,
  ) {}

  resetDropzoneUploads(): void {
    if (this.directiveRef) {
      this.directiveRef.reset();
    }
  }

  onFileSelected(event: Event) {
    this.filesSelected.emit(event);
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (!event.dataTransfer?.files) return;
    this.filesDropped.emit(Array.from(event.dataTransfer.files));
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragEnter(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onCancel(): void {
    this.dialogRef.close(false);
    this.resetDropzoneUploads();
  }
}
